import { render, staticRenderFns } from "./PropertyComplaintList.vue?vue&type=template&id=4792f0ec&scoped=true&"
import script from "./PropertyComplaintList.vue?vue&type=script&lang=js&"
export * from "./PropertyComplaintList.vue?vue&type=script&lang=js&"
import style0 from "./PropertyComplaintList.vue?vue&type=style&index=0&id=4792f0ec&scoped=true&lang=css&"
import style1 from "./PropertyComplaintList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4792f0ec",
  null
  
)

export default component.exports